/*------------------------------------*\
    SITE NAV§ 
\*------------------------------------*/


WW.siteNav = function($) {
    'use strict';

    const body = $('body'),
        siteNav = $('.js-site-nav'),
        state = {
            navOpen: false 
        };


    /*
        toggleSiteNav

        Main site nav toggled by burger
        button and adds overlay to body.
    */
    const toggleSiteNav = () => {
        if (state.navOpen) {
            body.css({
                overflow: 'visible',
                'padding-right' : 0
            });
            siteNav.removeClass('is-open');
        } else {
            body.css({
                overflow: 'hidden',
                'padding-right' : WW.scrollbarWidth
            });
            siteNav.addClass('is-open');
        }
        state.navOpen = !state.navOpen;
        body.find('.js-page-content')
            .toggleClass('js-site-nav-is-open site-nav-is-open');
    };


    /*
        toggleSubNav

        Handles toggles for sub menus to
        toggle a menu within it's parent.
    */
    const toggleSubNav = (e) => {
        e.preventDefault();
        $(e.currentTarget).closest('.js-site-nav__submenu-parent')
            .toggleClass('is-open');
    };


    /*
        setNavMaxHeight

        Sets max-height for mobile nav to enable a
        scrollbar when menu is bigger than screen.
    */
    const setNavMaxHeight = () => {
        const efficientFn = WW.debounce(setNavMaxHeight, 300),
            windowHeight = document.documentElement.clientHeight - siteNav.outerHeight();

        $('.c-site-nav__nav').css({maxHeight: windowHeight + 'px'});
        $(window).on('resize', efficientFn);
        $(window).on('orientationchange', setNavMaxHeight);
    };

    $('.js-site-nav__toggle').on('click', toggleSiteNav);
    $('.js-site-nav__submenu-toggle').on('click', toggleSubNav);

    setNavMaxHeight();


    return this;
};